import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { SyncSeatingOrderReducer } from '../../reducers/docs/syncSeatingOrder/types'

/**
 * Determines whether the Room has a valid state
 * @param state The Redux state
 */

const getSeats = (state: State): SyncSeatingOrderReducer['seatingOrder'] => state.syncSeatingOrder.seatingOrder
const getBTID = (state: State): string | null => state.user.BTID

export default createSelector<State, any, boolean>(
  [getSeats, getBTID],
  (seatingOrder, BTID) => {

    return !!(BTID && seatingOrder.hasOwnProperty(BTID))

  })
